import { getMangoApiClient } from '~/atoms/MangoApi'

import { createPbxLocationsApi } from '@mangovoice/pbx-locations-ui'

export const pbxLocationsApi = createPbxLocationsApi(
  getMangoApiClient().pbxLocations,
)
